module.exports = __webpack_public_path__ + "static/media/account_circle-24px.c20c4a93.svg";